// =============================================================================
// MeuDriver — CalendarExportButton (Batch T3)
// Botão reutilizável para exportar aulas como arquivo .ics
// =============================================================================

import { CalendarPlus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useExportToIcs } from '@/hooks/useCalendarExport'
import type { BookingForExport } from '@/hooks/useCalendarExport'

interface CalendarExportButtonProps {
  bookings: BookingForExport[]
  filename?: string
  disabled?: boolean
  variant?: 'default' | 'outline' | 'ghost' | 'secondary'
  size?: 'default' | 'sm' | 'lg' | 'icon'
  className?: string
}

export function CalendarExportButton({
  bookings,
  filename = 'meudriver-aulas',
  disabled,
  variant = 'outline',
  size = 'default',
  className,
}: CalendarExportButtonProps) {
  const exportToIcs = useExportToIcs()

  return (
    <Button
      variant={variant}
      size={size}
      disabled={disabled || bookings.length === 0}
      onClick={() => exportToIcs(bookings, filename)}
      className={className}
      data-testid="calendar-export-button"
      title={bookings.length === 0 ? 'Nenhuma aula para exportar' : 'Exportar para Calendário (.ics)'}
    >
      <CalendarPlus className="h-4 w-4 mr-2 shrink-0" />
      Exportar para Calendário
    </Button>
  )
}
